export default {
  PERSON: 'Name',
  LOCATION: 'Location',
  DATE: 'Date',
  EVENT: 'Reminder',
  ORGANIZATION: 'Organization',
  OTHER: 'Other',
  QUANTITY: 'Quantity',
  TITLE: 'Title',
  COMMERCIAL_ITEM: 'Commercial Item'
}
